<template>
<el-dialog
  :visible.sync="dialogVisible"
  :append-to-body="true"
  :close-on-click-modal="false"
  title="因子选择"
  width="700px"
  custom-class="custom-dialog"
>
  <div class="match-factor-form-wrapper">
    <label>请选择因子匹配关系</label>
    <div>
      <el-form
        ref="form"
        :model="model"
        hide-required-asterisk
        size="small"
        class="match-factor-form"
      >
        <template v-for="(config, index) in model.configs">
          <label :key="`${config.alias}-label`">{{config.alias}}</label>
          <el-form-item :key="`${config.alias}-select`" label="" :prop="`configs[${index}].factorId`" :rules="[{
            required: true,
            message: '请选择标准名称'
          }]">
            <el-select v-model="config.factorId" placeholder="请选择标准名称" clearable>
              <el-option
                v-for="factor in unmatchedStdFactors.filter(factor => !selectedMap[factor.factorId] || selectedMap[factor.factorId] === config.alias)"
                :key="factor.factorId"
                :value="factor.factorId"
                :label="factor.name"
              />
            </el-select>
          </el-form-item>
        </template>
      </el-form>
    </div>
  </div>

  <template slot="footer">
    <el-button type="orange" style="width:100px;" @click="onOkBtnClick">确定</el-button>
    <el-button style="width:100px;" @click="onCloseBtnClick">取消</el-button>
  </template>
</el-dialog>
</template>

<script>
import BaseStore from '../../../components/BaseStore'

export default {
  name: 'MatchFactorDialog',
  extends: BaseStore,
  props: {
    unmatchedFactors: {
      required: true,
      type: Array
    },
    unmatchedStdFactors: {
      required: true,
      type: Array
    }
  },
  data: () => ({
    dialogVisible: false,
    model: {
      configs: []
    }
  }),
  computed: {
    selectedMap () {
      return this.model.configs.reduce((map, config) => {
        let {factorId} = config

        if (factorId) {
          map[factorId] = config.alias
        }

        return map
      }, {})
    }
  },
  methods: {
    open () {
      this.model.configs = this.unmatchedFactors.map(unmatchedFactor => ({
        alias: unmatchedFactor.name,
        factorId: null
      }))
      this.dialogVisible = true

      setTimeout(() => {
        this.$refs.form.clearValidate()
      }, 0)
    },
    onOkBtnClick () {
      this.$refs.form.validate(flag => {
        if (flag) {
          this.changeLoadStatus(true)

          this.$api.FactorAlias.batchSaveFactors(this.model.configs).then(() => {
            this.dialogVisible = false
            this.$emit('saved-success')
          }).catch(console.error).finally(() => {
            this.changeLoadStatus(false)
          })
        }
      })
    },
    onCloseBtnClick () {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.match-factor-form-wrapper {
  display: grid;
  grid-template-rows: max-content auto;
  grid-row-gap: 5px;
  height: 370px;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }

  > div {
    border: 1px solid #E3E9ED;
    overflow: auto;
  }

  .match-factor-form {
    display: grid;
    grid-template-columns: max-content auto;
    grid-column-gap: 10px;
    align-items: flex-start;
    padding: 20px;

    > * {
      min: {
        width: 0;
        height: 0;
      }
    }

    > label {
      line-height: 32px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/05QC-Analysis/00Data/MatchFactorDialog.vue